import type { Driver } from "@/types/api";

// ISO («2020-09-08» или «2020-09-08T00:00:00Z») → «08.09.2020».
function fmtDate(s?: string): string {
  if (!s) return "";
  const iso = s.slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : s;
}

// Полные данные водителя для отправки в мессенджере — по запросу заказчика
// (#94): «чтобы можно было скопировать всё одним нажатием — паспорт, ИНН,
// водительское, телефон и всё остальное». Многострочный формат с подписями,
// в строку попадают только заполненные поля.
export function driverFullCopyText(d: Driver): string {
  const lines: string[] = [d.full_name];

  if (d.phone) lines.push(`Телефон: ${d.phone}`);
  if (d.mobile && d.mobile !== d.phone) lines.push(`Доп. телефон: ${d.mobile}`);
  if (d.citizenship) lines.push(`Гражданство: ${d.citizenship}`);
  if (d.inn) lines.push(`ИНН: ${d.inn}`);

  // Водительское удостоверение: номер, категория, кем и когда выдано, срок.
  if (d.license_number) {
    const lic: string[] = [`№ ${d.license_number}`];
    if (d.license_category) lic.push(`кат. ${d.license_category}`);
    if (d.license_issued_by) lic.push(`выдано ${d.license_issued_by}`);
    if (d.license_issued_at) lic.push(`от ${fmtDate(d.license_issued_at)}`);
    if (d.license_expires_at) lic.push(`действует до ${fmtDate(d.license_expires_at)}`);
    lines.push(`ВУ: ${lic.join(", ")}`);
  }

  // Паспорт: серия/номер, кем и когда выдан.
  if (d.passport_series || d.passport_number) {
    const pass: string[] = [`${d.passport_series ?? ""} ${d.passport_number ?? ""}`.trim()];
    if (d.passport_issued_by) pass.push(`выдан ${d.passport_issued_by}`);
    if (d.passport_issued_at) pass.push(`от ${fmtDate(d.passport_issued_at)}`);
    lines.push(`Паспорт: ${pass.join(", ")}`);
  }

  if (d.foreign_passport_number) lines.push(`Загранпаспорт: ${d.foreign_passport_number}`);
  if (d.medical_cert_expires_at) lines.push(`Мед. справка до: ${fmtDate(d.medical_cert_expires_at)}`);
  if (d.carrier_name) lines.push(`Перевозчик: ${d.carrier_name}`);
  if (d.notes) lines.push(`Примечание: ${d.notes}`);

  return lines.join("\n");
}
